import React, { useMemo } from 'react';

import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { IAppFile } from '../../../types/interfaces/app-file';
import { INewFile } from '../../../types/interfaces/new-file';
import { DEFAULT_HEIGHT, useStyles } from './AppImageGalleryContainer.styles';
import AppImageGalery from './ImageGallery';

type IFile = IAppFile | INewFile;

interface IAppImageGalleryContainerProps {
  files: IFile[];
  mainFileId?: string;
  height?: number;
}

export default function AppImageGalleryContainer({
  files,
  mainFileId,
  height = DEFAULT_HEIGHT,
}: IAppImageGalleryContainerProps) {
  const theme = useTheme();
  const { classes } = useStyles({ height });

  const orderedFiles = useMemo(() => {
    if (!files?.length) return [];
    if (!mainFileId) return files;
    const main = files.filter((f) => f.id === mainFileId);
    const rest = files.filter((f) => f.id !== mainFileId);
    return [...main, ...rest];
  }, [files, mainFileId]);

  if (!orderedFiles.length) return null;

  return (
    <Box className={classes.wrapper}>
      <AppImageGalery files={orderedFiles} />
    </Box>
  );
}
